var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.157,
    height: 69.226,
    viewBox: "0 0 80.157 69.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caution_Icon",
    "data-name": "Caution Icon",
    transform: "translate(-3.375 -8.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M1,71.226H81.157L41.078,2ZM44.722,60.3H37.435V53.009h7.287Zm0-14.574H37.435V31.148h7.287Z",
    transform: "translate(2.375 6.063)",
    fill: "#ffee17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/Warning_Icon.a2538b8752a0041a797aa75bf3f90695.svg";
export { ForwardRef as ReactComponent };